import React from 'react';
import Select, { StylesConfig } from 'react-select';
import { ISelectOption } from '../ISelectOption';
import { IBranche } from '../../../utils/types/IBranche';

interface BrancheSelectProps {
    branches: IBranche[];
    isBranchesLoading: boolean;
    setSelectedBrancheId: (brancheId: number) => void;
    selectedBrancheId: number | null;
}

const customStyles: StylesConfig<ISelectOption, false> = {
    control: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
        maxWidth: '100%',
    }),
    singleValue: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menu: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
    }),
    option: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
};

const BrancheSelect: React.FC<BrancheSelectProps> = ({ branches, isBranchesLoading, setSelectedBrancheId, selectedBrancheId }) => {
    const options: ISelectOption[] = branches.map((branche) => ({
        value: branche.id.toString(),
        label: branche.nom ?? '',
    }));

    const selectedOption = options.find((option) => option.value === selectedBrancheId?.toString()) || null;

    const handleChange = (selectedOption: ISelectOption | null) => {
        setSelectedBrancheId(selectedOption ? parseInt(selectedOption.value) : 0);
    };

    return <Select id="autoSizingSelect" options={options} value={selectedOption} onChange={handleChange} placeholder={isBranchesLoading ? 'Chargement ...' : '--- Branche'} isLoading={isBranchesLoading} isClearable isSearchable noOptionsMessage={() => 'Aucune branche'} styles={customStyles} classNamePrefix="react-select" menuPortalTarget={document.body} />;
};

export default BrancheSelect;
